import React, { useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
import ModalResult from '../ModalResult';

const ModalResetPassword = () => {
  const [form, setForm] = useState({});
  const [errorMessage, setErrorMessage] = useState();

  const handleForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
    if (form?.confirm_password !== form?.new_password) {
      setErrorMessage('Xác nhận mật khẩu không kớp');
    } else {
      setErrorMessage(null);
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    axios.post('api/v1/reset-password', { ...form }).then(({ data }) => {
      if (data.success) {
        $('#modal-form-reset-password')
          .removeClass('show')
          .css('display', 'none');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        // =>>>>>>>>>>>>>>>>
        $('#modal-result').addClass('show').css('display', 'block');
        $('body')
          .addClass('modal-open')
          .append("<div class='modal-backdrop fade show'></div>");
        return;
      }
      setErrorMessage('Mật khẩu cũ không đúng');
    });
  };
  return (
    <div
      className='modal fade modal-login'
      id='modal-form-reset-password'
      tabindex='-1'
      role='dialog'
    >
      <div className='modal-dialog modal-dialog-centered' role='document'>
        <div className='modal-content'>
          <div className='modal-success-content'>
            <h2>Thay đổi mật khẩu</h2>
            <form
              action=''
              method=''
              onSubmit={(e) => {
                handleLogin(e);
              }}
            >
              <div className='form-group'>
                <label>Mật khẩu cũ</label>
                <input
                  type='password'
                  name='current_password'
                  placeholder=''
                  onChange={(e) => {
                    handleForm(e.target.value, 'current_password');
                  }}
                />
              </div>
              <div className='form-group'>
                <label>Mật khẩu mới</label>
                <input
                  id='password-field-3'
                  type='password'
                  name='new_password'
                  placeholder=''
                  onChange={(e) => {
                    handleForm(e.target.value, 'new_password');
                  }}
                />
                <span
                  toggle='#password-field-3'
                  className='toggle-password'
                ></span>
              </div>
              <div className='form-group'>
                <label>Xác nhận mật khẩu mới</label>
                <input
                  id='password-field-4'
                  type='password'
                  name='confirm_password'
                  placeholder=''
                  onChange={(e) => {
                    handleForm(e.target.value, 'confirm_password');
                  }}
                />
                <span
                  toggle='#password-field-4'
                  className='toggle-password'
                ></span>
              </div>
              <p className='text-danger'>{errorMessage ? errorMessage : ''}</p>
              <button type='submit' className='btn_submit flex-center'>
                Đổi mật khẩu
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalResetPassword;
